import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import styled from "styled-components";
import moment from "moment";
import numberFormatter from "utils/numberFormatter";

const LeftAlignedGrid = styled(Grid)`
  && {
    text-align:left;
    margin-bottom:8px;
    font-size:17px;
  }
`;
const RightAlignedGrid = styled(Grid)`
  && {
    text-align:right;
    margin-bottom:8px;
    font-size:17px;
  }
`;
const DateText = styled.div`
  font-size:17px;
`;
const AggregateInterestResult = ({ result }) => (
  <>
    <LeftAlignedGrid item xs={6}>Next Payment Date</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}><DateText>{moment(result.calculationDate).format("MM/DD/YYYY")}</DateText></RightAlignedGrid>
    <LeftAlignedGrid item xs={6}>Aggregate Interest</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.aggregateInterest, 2, "-")}</RightAlignedGrid>
    <LeftAlignedGrid item xs={6}>Interest Paid</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.interestPaid, 2, "-")}</RightAlignedGrid>
  </>
);
export default AggregateInterestResult;
